export default {
  TagsEditor: {
    mounted() {
      window.tagsEditorHook = this;
      this.tags = "";
    },

    updateTags(tags) {
      // Convert list to semi-colon separated string
      this.tags = tags.join(";");

      // Update field value
      this.el.querySelector("input[type=hidden]").value = this.tags;

      // Fire validation event manually in case of "removing" a tag
      // since that action does not trigger any input changes
      this.el
        .querySelector("input[type=hidden]")
        .dispatchEvent(new Event("change", { bubbles: true }));
    },
  },
};
